/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import * as R from 'ramda';
import { useQuery } from '@apollo/client';
import GetSimulationCompanyQuery from '../graphql/queries/GetSimulationCompanyQuery.js';

const useGetSimulationCompanyQuery = (args) => {
  const { data, error, loading, refetch } = useQuery(GetSimulationCompanyQuery, args);

  return {
    error,
    loading,
    refetch,
    getSimulationCompany: R.omit(['__typename'], data?.getSimulationCompany_simulation_company || {})
  };
};

export default useGetSimulationCompanyQuery;
